module.exports = __webpack_public_path__ + "static/media/hotels-no-data.0b1d2d36.svg";